<template>
    <div class="modal fade createNewModal" id="AddModalTypeDocument" tabindex="-1" ref="addTypeDocumentModalRef"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-15 p-md-40">
                <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
                    <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
                </div>
                <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
                    <Form ref="typeDocumentForm" @submit="addTypeDocument" :validation-schema="typeDocumentSchema">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Code <span class="text-danger">*</span>
                                    </label>
                                    <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Entrez le libelle " />
                                    <ErrorMessage name="code" class="text-danger" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Libellé <span class="text-danger">*</span>
                                    </label>
                                    <Field name="libelle" type="text"
                                        class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Entrez le libelle " />
                                    <ErrorMessage name="libelle" class="text-danger" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Obligatoire <span class="text-danger">*</span>
                                    </label>
                                    <Field name="obligatoire" type="checkbox" :value="true" :unchecked-value="false"
                                        v-slot="{ field }">
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input" v-bind="field" />
                                            <label class="form-check-label ms-2">Oui</label>
                                        </div>
                                    </Field>
                                    <ErrorMessage name="obligatoire" class="text-danger" />
                                </div>
                            </div>

                            <button
                                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                                type="submit">
                                {{ btntext }}
                            </button>
                        </div>
                    </Form>
                </div>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
                    @click="resetValue()"></button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { TypeDocumentBesc } from '@/models/TypeDocument';

export default defineComponent({
    name: "AddModalTypeDocument",
    components: {
        Form,
        Field,
        ErrorMessage,

    },
    props: {
        item: {
            type: Number,
            default: 0,
        }
    },
    setup(props, { emit }) {
        const typeDocumentSchema = Yup.object().shape({
            code: Yup.string().required('Le code est obligatoire'),
            libelle: Yup.string().required('Le Libellé est obligatoire'),
            obligatoire: Yup.boolean().default(false)
        });

        const typeDocumentForm = ref<InstanceType<typeof Form> | null>(null);
        const addTypeDocumentModalRef = ref<null | HTMLElement>(null);
        const localItem = ref(props.item);
        const isUPDATE = ref(false);
        const title = ref("Ajoute une type de document");
        const btntext = ref('Ajouter');



        watch(() => props.item, (newValue) => {
            getTypeDocument(newValue);
            isUPDATE.value = true;
            btnTitle();
        });

        const btnTitle = async () => {
            if (isUPDATE.value) {
                title.value = "Modifier un type de document";
                btntext.value = "Modifier";
            } else {
                title.value = "Ajouter un type de document";
                btntext.value = "Ajouter";
            }
        }

        // const getTypeDocument = async (id: number) => {
        //     return ApiService.get("/typeDocumentBesc/" + id)
        //         .then(({ data }) => {
        //             const donnees = data.data;
        //             for (const key in donnees) {
        //                 typeDocumentForm.value?.setFieldValue(key,
        //                     (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
        //                 );
        //             }
        //             emit('openmodal', addTypeDocumentModalRef.value);

        //         })
        //         .catch(({ response }) => {
        //             error(response.data.message)
        //         });
        // }

        const getTypeDocument = async (id: number) => {
            if (id === 0) return;

            try {
                const { data } = await ApiService.get("/typeDocumentBesc/" + id);
                const donnees = data.data;

                // Remplir tous les champs du formulaire, y compris obligatoire
                typeDocumentForm.value?.setValues({
                    id: donnees.id,
                    code: donnees.code,
                    libelle: donnees.libelle,
                    obligatoire: Boolean(donnees.obligatoire), // convertit 1/0 ou true/false en boolean
                });

                // Ouvre la modal après chargement
                emit('openmodal', addTypeDocumentModalRef.value);
            } catch (err: unknown) {
                // Vérifier si c'est une erreur Axios avec response
                if (err && typeof err === 'object' && 'response' in err) {
                    const axiosError = err as { response?: { data?: { message?: string } } };
                    error(axiosError.response?.data?.message || 'Une erreur est survenue');
                } else {
                    error('Une erreur inattendue est survenue');
                }
            }
        };


        // const addTypeDocument = async (values: any, typeDocumentForm) => {
        //     values = values as TypeDocumentBesc;
        //     if (isUPDATE.value) {
        //         ApiService.put("/typeDocumentBesc/" + values.id, values)
        //             .then(({ data }) => {
        //                 if (data.code == 200) {
        //                     success(data.message);
        //                     typeDocumentForm.resetForm();
        //                     hideModal(addTypeDocumentModalRef.value);
        //                     isUPDATE.value = false;
        //                     btnTitle();
        //                     emit('close');
        //                 }
        //             })
        //             .catch(({ response }) => {
        //                 error(response.data.message);
        //             });
        //     } else {
        //         ApiService.post("/typeDocumentBesc", values)
        //             .then(({ data }) => {
        //                 if (data.code == 201) {
        //                     success(data.message);
        //                     typeDocumentForm.resetForm();
        //                     hideModal(addTypeDocumentModalRef.value);
        //                     emit('close');
        //                 }
        //             })
        //             .catch(({ response }) => {
        //                 error(response.data.message);
        //             });
        //     }
        // };



        // const resetValue = () => {
        //     const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        //     isUPDATE.value = false;
        //     formFields.forEach(field => {
        //         field.value = '';
        //     });
        //     btnTitle()
        // };

        const addTypeDocument = async (values: any, { resetForm }: any) => {
            values = values as TypeDocumentBesc;

            try {
                let response;
                if (isUPDATE.value) {
                    response = await ApiService.put("/typeDocumentBesc/" + values.id, values);
                } else {
                    response = await ApiService.post("/typeDocumentBesc", values);
                }

                if (response.data.code === 200 || response.data.code === 201) {
                    success(response.data.message);
                    resetForm();
                    hideModal(addTypeDocumentModalRef.value);
                    isUPDATE.value = false;
                    await btnTitle(); // async mais pas grave
                    emit('close');
                }
            } catch (err: unknown) {
                if (err && typeof err === 'object' && 'response' in err) {
                    const axiosError = err as { response?: { data?: { message?: string } } };
                    error(axiosError.response?.data?.message || 'Une erreur est survenue');
                } else {
                    error('Erreur inattendue');
                }
            }
        };
        const resetValue = () => {
            typeDocumentForm.value?.resetForm(); // Réinitialise proprement tous les champs
            isUPDATE.value = false;
            btnTitle();
        };
        return {
            typeDocumentSchema,
            addTypeDocumentModalRef,
            addTypeDocument,
            typeDocumentForm,
            title, btntext, resetValue,

        };
    },
});
</script>